<div class="fluxEtapeIcon" *ngIf="getEtapeLogo()" style="background-color: {{ backgroundColor }}; width: {{ wrapperWidth }}; height: {{ wrapperHeight }};">
  <img [src]="getEtapeLogo()"
    [title]="title ?? 'Aucune'"
    width="{{ imageWidth }}"
    height="{{ imageHeight }}"
    alt="Logo de l'étape en cours"
  />
</div>